<template lang="pug">
  .card.height-100
    .card-body
      .columns.align-center
        .column.col-auto
          user-avatar.avatar-lg(:user="person")
        .column.text-ellipsis
          .text-bold.text-ellipsis {{ person.fullName }}
          .text-small.text-ellipsis {{ person.email }}
    .card-footer
      .columns.align-center
        .column
          .text-small Adicionado em #[span.text-bold {{ person.createdAt | toDate('DD/MM/YYYY') }}]
        .column.col-auto
          router-link.btn.btn-action.btn-sm.btn-link.tooltip(
            :to="{ name: routeName, params: { id: person.id } }"
            data-tooltip="Editar"
          )
            i.fas.fa-edit
</template>

<script>
export default {
  props: {
    person: { type: Object, required: true },
    routeName: { type: String, required: true },
  },
}
</script>
